<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <div>
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="卡组编号：" prop="name">
              <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入卡组编号"></el-input>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="operaBtn(1)" v-loading.fullscreen.lock="fullscreenLoading">激活</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="operaBtn(2)" v-loading.fullscreen.lock="fullscreenLoading">作废</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="exportExcelBtn">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          border
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="infoList">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardName"
            label="礼品卡名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardNo"
            label="卡号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardPassword"
            label="卡密">
          </el-table-column>
          <el-table-column
            align="center"
            prop="faceValuePrice"
            label="面额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="activeStatus"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.activeStatus == 0">未激活</span>
              <span v-else-if="scope.row.activeStatus == 1" class="color-theme">已激活</span>
              <span v-else>已作废</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="useStatus"
            label="是否使用">
            <template slot-scope="scope">
              <span v-if="scope.row.useStatus == 1" class="color-theme">已使用</span>
              <span v-else>未使用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="activeDateTime"
            label="激活时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cancelDateTime"
            label="作废时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="useDateTime"
            label="使用时间">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryGiftCardMinePageList, activeBatchCardMine,cancelBatchCardMine,exportExcel } from '@/api/giftCard'
export default {
  name: 'WatchCardGroup',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      multipleSelection: []
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出操作
    exportExcelBtn(){
      var dataId = this.dataId;
      let searchName = this.searchForm.name
      var that = this;
      exportExcel({ cardDeckId: dataId, cardNo: searchName }).then((res) => {
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '卡密列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    // type 1批量激活 2批量作废
    operaBtn(type){
      var multipleSelection = this.multipleSelection;
      var idList = [];
      multipleSelection.forEach(function(item){
        idList.push(item.id);
      });
      if(idList.length == 0){
        this.$message.error('请选择卡密');
        return false;
      }
      var typeTxt = type == 1 ? '激活' : '作废';
      var that = this;
      this.$confirm('确认'+typeTxt+'选中的卡密吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        if(type == 1){
          // 批量激活
          activeBatchCardMine({ idList: idList }).then((res) => {
            that.backDataFun(res)
          })
        }else{
          // 批量作废
          cancelBatchCardMine({ idList: idList }).then((res) => {
            that.backDataFun(res)
          })
        }
      }).catch(() => {})
    },
    backDataFun(res){
      var that = this
      that.fullscreenLoading = false
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.getInfoList();
          }
        })
      }
      if (res.errorCode === '1001') {
        that.$message.error(res.msg)
      }
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let dataId = that.dataId
      let page = that.currentPage
      queryGiftCardMinePageList({ cardDeckId: dataId, cardNo: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/giftCard/WatchCardGroup.vue